import React from 'react';
import OverlayBtn from './OverlayBtn';

const OverlayBtnContainer = () => {
  return <OverlayBtn intOptionId='overlayBtn' />;
};

export default OverlayBtnContainer;
